import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import {TaskType, TaskTypeStrMap} from "../../domain/enums/task-type.enum";


@Component({
  selector: 'app-request-type-indicator',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './request-type-indicator.component.html',
  styleUrl: './request-type-indicator.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestTypeIndicatorComponent {
  @Input() taskType: string | undefined;

  /** Registered SVG icon for the type, or null to fall back to a font icon ('help-icon' was never registered, so its name printed as text). */
  getIconForTaskType(taskType: string): string | null {
    if (!taskType) {
      return null;
    }
    switch (taskType) {
      case TaskType.NEW_CUSTOMER:
        return 'vector-icon';
      case TaskType.NEW_PROPERTY:
        return 'home-icon';
      case TaskType.REMOVE_PROPERTY:
        return 'delete-icon';
      case TaskType.UPDATE_HOLIDAYS:
        return 'date-range-icon';
      case TaskType.UPDATE_INTEREST_RATE:
        return 'percent-icon';
      case TaskType.INACTIVATE_RENTAL_PROPERTY:
        return 'pause-icon'
      default:
        return null;
    }
  }

  protected readonly TaskType = TaskType;
  protected readonly TaskTypeStrMap = TaskTypeStrMap;
}
